define([
    "./monitoringQueryModule",
    "./monitoringQueryController",
    "./monitoringQueryListController",
    "./monitoringQueryService",
    "./edition/monitoringQueryEditionController",
    "./search/monitoringQuerySearchController"
], function () {
});